import React from 'react';
import classes from '../styles/style.module.css'
import getProfileImage from '../../../assets/Hooks/getProfileImage';

const HubbleScoreListElement = () => {
  return (
    <div className={classes.userListElement} >
    <div className="d-flex justify-content-between align-items-center">
      <div className={classes.AvatarRate}>{getProfileImage("")}</div>
      <div>
        <p className={classes.userName}>علیرضا شفیعیون</p>
        <p className={classes.rateText}>رتبه ۱</p>
      </div>
    </div>
    <p className={classes.rate}>1</p>
  </div>

  )
}

export default HubbleScoreListElement